(() => {
  if (window.lucidiusNewsletterPopup) return;
  window.lucidiusNewsletterPopup = true;

  const W = window;
  const D = document;
  const now = () => Date.now();
  const storage = (name) => {
    try {
      const s = W[name];
      s.setItem('lnp_t', '1');
      s.removeItem('lnp_t');
      return s;
    } catch (e) {
      return null;
    }
  };
  const session = storage('sessionStorage');
  const local = storage('localStorage') || session;
  const get = (s, key) => {
    try {
      return s?.getItem('lnp_' + key);
    } catch (e) {}
  };
  const set = (s, key, value) => {
    try {
      s?.setItem('lnp_' + key, value);
    } catch (e) {}
  };
  const track = (event, data) => {
    try {
      if (typeof W.dataLayer?.push !== 'function') return;
      if (W.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) return;
      W.dataLayer.push({ event, ...data });
    } catch (e) {}
  };
  const visible = (el) => {
    const style = el?.getClientRects().length && getComputedStyle(el);
    return !!style && style.visibility !== 'hidden' && +style.opacity > 0.05;
  };
  const cookieBanner = () => {
    const wrap = D.getElementById('pandectes-banner');
    const box = wrap?.querySelector('.cc-window') || wrap;
    return visible(wrap) && visible(box) && !box.classList.contains('cc-invisible');
  };
  const consentCookie = () => {
    const match = D.cookie.match(/(?:^|;\s*)_pandectes_gdpr=([^;]+)/);
    if (!match) return null;
    try {
      return JSON.parse(atob(decodeURIComponent(match[1]))).status || '';
    } catch (e) {
      return '';
    }
  };
  const busy = () =>
    /\boverflow-hidden/.test(D.body.className) ||
    !!D.querySelector('dialog[open]') ||
    !!D.activeElement?.matches('textarea,input:not([type=radio],[type=checkbox],[type=button],[type=submit],[type=range])');

  let atc = 0;
  D.addEventListener('click', (e) => {
    if (e.target.closest?.('[name="add"],[data-lnp-atc]')) atc = now();
  }, true);
  D.addEventListener('submit', (e) => {
    if (/\/cart\/add/.test(e.target.getAttribute('action') || '')) atc = now();
  }, true);

  let current = null;

  const init = (root) => {
    const configEl = root.querySelector('[data-lnp-config]');
    const tpl = root.querySelector('template[data-lnp-tpl]');
    if (!configEl || !tpl) return;
    let c;
    try {
      c = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    const editor = !!c.editor;

    const open = (state, trigger) => {
      if (current) return;
      const prev = D.activeElement;
      const frag = tpl.content.cloneNode(true);
      const overlay = frag.querySelector('[data-lnp-overlay]');
      const panel = frag.querySelector('[data-lnp-panel]');
      const form = frag.querySelector('form');
      const email = frag.querySelector('[data-lnp-email]');
      const consent = frag.querySelector('[data-lnp-consent]');
      const err = frag.querySelector('[data-lnp-err]');
      const done = frag.querySelector('[data-lnp-step="success"]');
      const nodes = [...frag.childNodes];
      let closed = false;

      frag.querySelectorAll('.lnp__consent a[href]').forEach((a) => {
        a.target = '_blank';
        a.rel = 'noopener';
        a.setAttribute('aria-describedby', 'a11y-new-window-message');
      });
      form.noValidate = true;

      const focusables = () =>
        [...panel.querySelectorAll('a[href],button,input:not([type="hidden"])')].filter(
          (el) => !el.disabled && el.getClientRects().length
        );
      const onKey = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          close('esc');
        } else if (e.key === 'Tab') {
          const list = focusables();
          const first = list[0];
          const last = list[list.length - 1];
          if (e.shiftKey && (D.activeElement === first || D.activeElement === panel)) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && D.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      };
      const onFocus = (e) => {
        if (!panel.contains(e.target)) panel.focus();
      };
      const close = (how) => {
        if (closed) return;
        closed = true;
        current = null;
        nodes.forEach((n) => n.remove());
        D.removeEventListener('keydown', onKey, true);
        D.removeEventListener('focusin', onFocus, true);
        if (!editor) {
          if (how !== 'done') set(local, 'dismissed', String(now()));
          track('lnp_close', { lnp_method: how });
        }
        if (D.contains(prev)) prev.focus?.({ preventScroll: true });
      };
      const showError = (message, field) => {
        err.textContent = message;
        [email, consent].forEach((el) => el.setAttribute('aria-invalid', String(el === field)));
        field.focus();
      };

      overlay.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-lnp-close]');
        if (btn) close(btn.getAttribute('data-lnp-close'));
        else if (e.target === overlay) close('backdrop');
      });
      form.addEventListener('submit', (e) => {
        const value = email.value.trim();
        email.value = value;
        if (!value || !email.checkValidity()) {
          e.preventDefault();
          return showError(c.msg.email, email);
        }
        if (!consent.checked) {
          e.preventDefault();
          return showError(c.msg.consent, consent);
        }
        if (editor) return e.preventDefault();
        err.textContent = '';
        set(session, 'pending', String(now()));
        track('lnp_submit');
        const btn = form.querySelector('[type="submit"]');
        btn.setAttribute('aria-busy', 'true');
        D.removeEventListener('focusin', onFocus, true);
        setTimeout(() => btn.removeAttribute('aria-busy'), 8000);
      });

      if (state === 'success') {
        done.previousElementSibling.hidden = true;
        done.hidden = false;
        panel.setAttribute('aria-labelledby', done.querySelector('h2').id);
      }

      current = { root, close };
      D.body.appendChild(frag);
      D.addEventListener('keydown', onKey, true);
      D.addEventListener('focusin', onFocus, true);

      if (state === 'error') {
        email.setAttribute('aria-invalid', 'true');
        email.focus();
      } else if (state === 'success') {
        done.querySelector('button').focus();
      } else {
        panel.focus();
      }

      if (editor) return;
      if (state === 'success') {
        set(local, 'subscribed', '1');
        track('lnp_success');
      } else if (trigger) {
        set(session, 'shown', '1');
        track('lnp_view', { lnp_trigger: trigger });
      }
    };

    if (editor) return open(c.editor === 'success' ? 'success' : 'form');

    const url = new URL(W.location.href);
    const posted = url.searchParams.get('customer_posted') === 'true';
    const pending = +get(session, 'pending');
    const ours = W.location.hash === '#' + c.form || (pending && now() - pending < 6e5);
    set(session, 'pending', '');
    if (posted) set(local, 'subscribed', '1');
    if (ours && (posted || c.ok || c.err)) {
      url.searchParams.delete('customer_posted');
      url.hash = '';
      try {
        history.replaceState(history.state, '', url.pathname + url.search);
      } catch (e) {}
      return open(c.err && !posted ? 'error' : 'success');
    }

    const views = +(get(session, 'views') || 0) + 1;
    set(session, 'views', String(views));
    const params = url.searchParams;
    if (/email/i.test((params.get('utm_source') || '') + ' ' + (params.get('utm_medium') || '')) || params.get('ref') === 'shopify_email') {
      set(session, 'from_email', '1');
    }
    const blocked = () => {
      const dismissed = +get(local, 'dismissed');
      return (
        !session ||
        get(local, 'subscribed') ||
        get(session, 'shown') ||
        get(session, 'from_email') ||
        (dismissed && now() - dismissed < c.hours * 36e5)
      );
    };
    if (blocked() || views < c.pv) return;

    const mobile = matchMedia('(max-width: 749px)').matches || !matchMedia('(hover: hover) and (pointer: fine)').matches;
    let loadedAt = D.readyState === 'complete' ? now() : 0;
    let bannerSeen = false;
    if (!loadedAt) W.addEventListener('load', () => (loadedAt = now()), { once: true });
    const consentReady = () => {
      if (cookieBanner()) {
        bannerSeen = true;
        return false;
      }
      const status = consentCookie();
      return bannerSeen || !!status || (loadedAt && now() - loadedAt > (status === null ? 2500 : 8000));
    };
    const canOpen = () =>
      consentReady() && !busy() && D.visibilityState === 'visible' && now() - atc > c.atc * 1000;

    let fired = false;
    const cleanups = [];
    const fire = (trigger) => {
      if (fired) return;
      fired = true;
      cleanups.forEach((fn) => fn());
      const attempt = () => {
        if (blocked() || current) return;
        if (canOpen()) open('form', trigger);
        else setTimeout(attempt, 1000);
      };
      attempt();
    };
    const arm = () => {
      const timer = setTimeout(() => fire('time'), c.sec * 1000);
      cleanups.push(() => clearTimeout(timer));
      const depth = (mobile ? c.sm : c.sd) / 100;
      const onScroll = () => {
        const range = D.documentElement.scrollHeight - W.innerHeight;
        if (range > 0 && W.scrollY / range >= depth) fire('scroll');
      };
      W.addEventListener('scroll', onScroll, { passive: true });
      cleanups.push(() => W.removeEventListener('scroll', onScroll));
      if (c.exit && !mobile) {
        const onOut = (e) => {
          if (!e.relatedTarget && e.clientY < 10) fire('exit');
        };
        D.addEventListener('mouseout', onOut);
        cleanups.push(() => D.removeEventListener('mouseout', onOut));
      }
    };
    const wait = () => (consentReady() ? arm() : setTimeout(wait, 1000));
    wait();
  };

  const start = () => D.querySelectorAll('.lnp-section').forEach(init);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  D.addEventListener('shopify:section:load', (e) => init(e.target));
  D.addEventListener('shopify:section:unload', (e) => {
    if (current && e.target.contains(current.root)) current.close('editor');
  });
})();
